import Block from './Block';

export default class Madlib extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    setTimeout(() => {
      this.$image.classList.add('visible')
    }, 1000)
  }

  getElems() {
    super.getElems()

    this.$firstLevelSelect = this.el.querySelector('.b-madlib__first')
    this.$secondLevelSelect = this.el.querySelector('.b-madlib__second')
    this.$firstItems = this.el.querySelectorAll('.b-madlib__first-item')
    this.$secondItems = this.el.querySelectorAll('.b-madlib__second-item')
    this.$madlibButton = this.el.querySelector('.b-madlib__btn')
    this.$image = this.el.querySelector('.b-madlib__img')
    this.firstPlaceholder = this.el.querySelector('.b-madlib__first-placeholder')
    this.secondPlaceholder = this.el.querySelector('.b-madlib__second-placeholder')
    this.madlib = {}

    this.firstSelected = false;
    this.secondSelected = false;

    this.madlib[0] = [this.secondPlaceholder]

    for (let i = 0; i < this.$firstItems.length; i++) {
      const firstElement = this.$firstItems[i]
      const secondArray = []

      secondArray.push(this.secondPlaceholder)

      for (let j = 0; j < this.$secondItems.length; j++) {
        const secondElement = this.$secondItems[j];

        if (firstElement.dataset.id === secondElement.dataset.id) {
          secondArray.push(secondElement)
        }
      }

      this.madlib[i + 1] = secondArray
    }

    console.log(this.madlib);
    this.sortSecondItems(this.madlib[0])
  }


  events() {
    super.events()

    this.$firstLevelSelect.addEventListener('input', (e) => {
      const options = e.target;

      for (let i = 0; i < options.length; i++) {
        const element = options[i];

        if (element.selected) {
          if (i === 0) {
            this.firstSelected = false
            this.secondSelected = false
            this.sortSecondItems(this.madlib[0])
          } else {
            this.firstSelected = true
            this.currentFirstId = element.dataset.id
            this.currentSecondItems = this.madlib[this.currentFirstId]
            this.sortSecondItems(this.currentSecondItems)
          }

          if (this.firstSelected && this.secondSelected) this.enableButton()
          else this.disableButton()
        }
      }
    })

    this.$secondLevelSelect.addEventListener('input', (e) => {
      const options = e.target;

      for (let i = 0; i < options.length; i++) {
        const element = options[i];

        if (element.selected) {
          if (i === 0) this.secondSelected = false
          else {
            this.secondSelected = true
            this.setUrl(element.value)
          }

          if (this.firstSelected && this.secondSelected) this.enableButton()
          else this.disableButton()
        }
      }
    })
  }

  enableButton() {
    this.$madlibButton.classList.remove('disabled')
  }

  disableButton() {
    this.$madlibButton.classList.add('disabled')
  }

  sortSecondItems(elements) {
    this.$secondLevelSelect.innerHTML = ''
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i];

      this.$secondLevelSelect.appendChild(element)
    }
    this.$secondLevelSelect.children[0].selected = true
    this.setUrl(this.$secondLevelSelect.children[0].value)
  }

  setUrl(url) {
    this.$madlibButton.href = url
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Madlib.js